// extracted by mini-css-extract-plugin
export var alert = "LoginDialog-module--alert--M5jvk";
export var box = "LoginDialog-module--box--Koh3v";
export var component = "LoginDialog-module--component--rvoi9";
export var description = "LoginDialog-module--description--OxJJV";
export var headline = "LoginDialog-module--headline--oXmO-";
export var list = "LoginDialog-module--list--4rFgL";
export var logo = "LoginDialog-module--logo--yvME9";
export var nav = "LoginDialog-module--nav--HfPZ-";
export var wrapper = "LoginDialog-module--wrapper--3NX1F";